export const translations = {
	nav: {
		title: 'Navegación',
		app: 'Certificado de donación',
	},
	footer: {
		poweredBy: 'Hecho por',
		copyright: '© {{year}} WorldCoo. Todos los derechos reservados.',
		termsAndConditions: 'Términos y condiciones',
		privacyPolicy: 'Política de privacidad',
	},
	categories: {
		basicNeeds: 'Agua y Energía',
		humanRights: 'Derechos Humanos',
		education: 'Educación',
		emergency: 'Emergencias',
		feeding: 'Hambre y Seguridad Alimentaria',
		environment: 'Medio Ambiente',
		habitat: 'Vivienda y Pobreza',
		health: 'Salud',
	},
	statistics: {
		campaigns: 'Campañas',
		donations: 'Donaciones',
		collected: 'Recaudado',
		collectedFromBudget: 'Objetivo de {{budget}}',
	},
	filters: {
		year: 'Año',
		state: 'Estado',
		cause: 'Causa',
		active: 'Activa',
		finished: 'Finalizada',
		default: 'Por defecto',
		toggle: 'Alternar {{value}}',
	},
	actions: {
		close: 'Cerrar',
		search: 'Busca cualquier cosa',
		filter: 'Filtrar',
		viewCampaign: 'Ver campaña',
		makeDonation: 'Hacer donación',
		donate: 'Donar',
		selectLanguage: 'Seleccionar idioma',
		backToHome: 'Volver al inicio',
		funded: 'Financiado',
		clear: 'Limpiar Filtros',
		apply: 'Aplicar',
		goBack: 'Volver',
		previous: 'Anterior',
		next: 'Siguiente',
	},
	portal: {
		heroButton: 'Empieza a donar',
		campaigns: {
			title: 'Campañas',
			description: 'Explora nuestras iniciativas y elige la causa que más te inspire',
			notFound: 'No hay campañas',
		},
		campaignFunded: 'Campaña financiada',
		percentageFunded: '{{percentage}}% Financiada',
		aCampaignFrom: 'Una campaña de: {{ngoName}}',
		beneficiaries: 'Beneficiarios',
		directBeneficiaries: '{{count}} directos',
		indirectBeneficiaries: '{{count}} indirectos',
		sdgs: {
			title: 'Objetivos de Desarrollo Sostenible',
			1: 'Fin de la Pobreza',
			2: 'Hambre Cero',
			3: 'Salud y Bienestar',
			4: 'Educación de Calidad',
			5: 'Igualdad de Género',
			6: 'Agua Limpia y Saneamiento',
			7: 'Energía Asequible y No Contaminante',
			8: 'Trabajo Decente y Crecimiento Económico',
			9: 'Industria, Innovación e Infraestructura',
			10: 'Reducción de las Desigualdades',
			11: 'Ciudades y Comunidades Sostenibles',
			12: 'Producción y Consumo Responsables',
			13: 'Acción por el Clima',
			14: 'Vida Submarina',
			15: 'Vida de Ecosistemas Terrestres',
			16: 'Paz, Justicia e Instituciones Sólidas',
			17: 'Alianzas para Lograr los Objetivos',
		},
	},
	faq: {
		title: 'Preguntas frecuentes',
		description: 'Respuestas a las dudas más comunes de nuestros donantes.',
	},
	campaign: {
		objectives: 'Objetivos de la campaña',
		description: 'Descripción',
		activities: 'Actividades',
		beneficiaries: '¿Quién se beneficiará?',
		updatesAndLinks: 'Más información y enlaces',
		from: 'Desde:',
		until: 'Hasta:',
	},
	campaigns: {
		notTranslated: 'Este proyecto todavía no está disponible en tu idioma.',
	},
	placeholders: {
		amount: 'Otra cantidad',
	},
	donate: {
		title: 'Realiza tu donación',
		details: {
			title: 'Añade tus datos para continuar',
			subtitle: 'Completa tus datos para finalizar tu donación. También puedes solicitar tu certificado fiscal aquí.',
		},
		certificate: {
			title: 'Recupera hasta {{amount}}',
			subtitle: 'Certifica tu donación con un clic y automáticamente aparecerá en tu borrador de la Renta.',
		},
	},
	errors: {
		required: 'Este campo es obligatorio',
		invalidExtref: 'El código es inválido, tiene que seguir este formato: {{format}}',
		email: 'La dirección de correo electrónico está mal formateada.',
		emailAlreadyExists: 'Este correo electrónico ya está en uso.',
		password: 'Tu contraseña debe tener 6 caracteres o más.',
		confirmationCode: 'Por favor, introduce el código de confirmación.',
		documentType: 'Tipo de documento inválido',
		termsAndConditions: 'Debes aceptar los términos y condiciones',
		amount: 'Por favor, selecciona o introduce una cantidad válida.',
		signIn: 'Error al iniciar sesión',
		emailsDoNotMatch: 'Las direcciones de correo electrónico no coinciden.',
		passwordsDoNotMatch: 'Las contraseñas no coinciden.',
		imageFormat: 'Por favor, suelta un archivo de imagen',
		camera: 'No se puede acceder a la cámara. Por favor, asegúrate de haber otorgado permiso.',
		expiredCode: 'El código ha caducado.',
		codeMismatch: 'El código es incorrecto. Por favor, inténtalo de nuevo.',
		notAuthorized: 'Credenciales incorrectas. Por favor, inténtalo de nuevo.',
		userDoesNotExist: 'El usuario no existe.',
		userNotConfirmed: 'Usuario no confirmado. Por favor, confirma tu dirección de correo electrónico primero.',
		userAlreadyConfirmed: 'El usuario ya ha sido confirmado.',
		documentNumberExists: 'El número de documento ya está en uso.',
		limitExceeded: 'Has alcanzado el límite de intentos. Por favor, inténtalo de nuevo más tarde.',
		invalidPassword: 'La contraseña es inválida, debe tener al menos 6 caracteres y no puede contener espacios.',
		captchaFailed: 'La verificación CAPTCHA ha fallado. Por favor, inténtalo de nuevo.',
		internal:
			'Lo sentimos, ha habido un problema, nuestro equipo ya ha sido informado, inténtelo nuevamente más tarde.',
	},
	documentTypes: {
		id: 'DNI',
		passport: 'Pasaporte',
		taxId: 'Identificación fiscal',
		nie: 'NIE',
		others: 'Otros',
	},
	labels: {
		code: 'Código',
		email: 'Correo electrónico',
		repeatEmail: 'Repite tu correo electrónico',
		password: 'Contraseña',
		confirmPassword: 'Confirmar contraseña',
		amount: 'Cantidad de donación',
		documentType: 'Tipo de documento',
		documentNumber: 'Número de documento',
		name: 'Nombre',
		lastName: 'Apellido',
		streetName: 'Nombre de la calle',
		streetNumber: 'Número',
		additionalInfo: 'Información adicional',
		postalCode: 'Código postal',
		city: 'Ciudad',
		country: 'País',
		region: 'Región',
		province: 'Provincia',
		certificate: 'Quiero recibir un certificado fiscal',
		termsAndConditions1:
			'Esta información solo se compartirá con las organizaciones receptoras de tus donaciones con el fin de generar el correspondiente certificado fiscal. Lee los ',
		termsAndConditions2: 'términos y condiciones',
		language: 'Idioma',
		newsletter:
			'Suscríbete para mantenerte al día con las causas que apoyamos, los proyectos que financiamos y las personas que empoderamos en todo el mundo.',
	},
	checkout: {
		title: 'Método de pago',
	},
	recaptcha: {
		description: 'protegido por reCAPTCHA.',
		privacy: 'Privacidad',
		terms: 'Términos',
	},
	thanks: {
		title: '¡Gracias\n por tu donación!',
		description:
			'En breve recibirás un correo de confirmación con todos los detalles. ¡Juntos estamos construyendo un futuro mejor!',
	},
	termsAndConditions: {
		title: 'Términos de Protección de datos',
		labelText: 'He leído, entiendo y acepto los términos de ',
		labelLink: 'Protección de Datos de {{name}}',
		accept: 'He leído, entiendo y acepto',
		responsible: {
			title: 'Responsable',
			description: 'WORLDCOO S.L.',
		},
		purpose: {
			title: 'Finalidad',
			description:
				'Gestionar la relación negocial en todos sus ámbitos, así como su donación y su solicitud de certificado, y el envío de comunicaciones comerciales por vía electrónica.',
			descriptionNgo:
				'La captación de fondos para proyectos de la ONG, mantenerle informado sobre la ONG y la evolución del proyecto para el que ha donado fondos y la emisión de certificados de desgravación fiscal.',
		},
		legitimacy: {
			title: 'Legitimación',
			description: 'La base legal para el tratamiento de sus datos es la obtención de su consentimiento.',
		},
		recipients: {
			title: 'Destinatarios',
			description: 'No se cederán datos a terceros salvo que exista obligación legal para ello.',
		},
		rights: {
			title: 'Derechos',
			description:
				'Tiene derecho a acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información adicional.',
		},
		additionalInfo: {
			title: 'Información adicional',
			description:
				'Puede consultar información adicional y detallada sobre Protección de Datos en nuestra página <a href="https://www.worldcoo.com/gdpr">web</a> o bien contactando en <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>.',
			descriptionNgo:
				'Puede consultar la información adicional y detallada sobre Protección de Datos en la web de cada ONG.\n\n<b>{{ngoName}}</b>',
		},
	},
};
